/* eslint-disable no-bitwise */
export const createUUID = () => {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}

	// Fallback for older browsers
	let timestamp = new Date().getTime();
	let performanceTime =
		typeof performance !== 'undefined' && performance.now
			? performance.now()
			: 0;

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		let r = (timestamp + performanceTime + Math.random() * 16) % 16 | 0;
		timestamp = Math.floor(timestamp / 16);
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
};